import React from 'react';
import { motion } from 'framer-motion';
import { Headphones, Moon, BrainCircuit, Activity } from 'lucide-react';
import './WhyChooseSection.css';

const features = [
  {
    icon: <Headphones size={32} />,
    title: "Stress Relief Made Simple",
    description: "Escape daily pressure with calming sounds and peaceful music designed to help you reset mentally."
  },
  {
    icon: <Moon size={32} />,
    title: "Better Sleep Naturally",
    description: "Create the perfect bedtime atmosphere and enjoy deeper, more refreshing sleep."
  },
  {
    icon: <BrainCircuit size={32} />,
    title: "Improve Focus & Productivity",
    description: "Use soothing audio sessions while working or studying to stay calm and concentrated."
  },
  {
    icon: <Activity size={32} />,
    title: "Easy Daily Habit",
    description: "Just 20 minutes a day can help improve emotional balance and well-being."
  }
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
};

const WhyChooseSection = () => {
  return (
    <section id="features" className="section-padding why-choose-section">
      <div className="container">
        <motion.div 
          className="section-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
        >
          <h2>Why Choose <span className="text-primary">Relax</span></h2>
          <p>Transform your daily routine into a wellness journey.</p>
        </motion.div>

        <motion.div 
          className="benefits-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          {features.map((feature, index) => (
            <motion.div key={index} className="benefit-card" variants={itemVariants}>
              <div className="benefit-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default WhyChooseSection;
